"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _axios = _interopRequireDefault(require("axios"));

module.exports = /*#__PURE__*/function () {
  function URLExplorer(url) {
    (0, _classCallCheck2["default"])(this, URLExplorer);
    this.url = url;
  }

  (0, _createClass2["default"])(URLExplorer, [{
    key: "getExchangeRate",
    value: function getExchangeRate() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _axios["default"].get(_this.url).then(function (response) {
          resolve(response.data);
        });
      });
    }
  }]);
  return URLExplorer;
}();